import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";
import { imageWithAlt } from "../objects";

export default defineType({
  title: "Offer Highlight Emotional Launcher",
  name: "offerHighlightEmotionalLauncher",
  type: "object",
  fields: [
    {
      name: "offer",
      title: "Offer",
      type: "reference",
      to: [{ type: "exclusiveOfferPerPromo" }],
      validation: (Rule) => Rule.required()
    },
    {
      name: "backgroundImage",
      title: "Background Image",
      type: imageWithAlt.name,
      description: "If empty, the offer's default image will be used"
    }
  ],
  preview: {
    select: {
      title: "offer.title",
      media: "backgroundImage"
    },
    prepare({ title, media }) {
      return {
        title: multilingualStringPreview(title) || "Offer Highlight Emotional Launcher",
        media
      };
    }
  }
});
